import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from "../components/profile/mfes/Auth";
import Garage from "../components/profile/mfes/Garage";
import Settings from "../components/profile/mfes/Settings";
import Profile from "../components/profile/Profile.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'abstract',
    routes: [
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            children: [
                {
                    path: 'auth/:page*',
                    name: 'auth',
                    component: Auth,
                },
                {
                    path: 'garage/:page*',
                    name: 'garage',
                    component: Garage,
                },
                {
                    path: 'settings/:page*',
                    name: 'settings',
                    component: Settings,
                }
            ]
        }
    ],
});

/**
 * Some backend routes such as /login needs to open Profile MFE
 * to the certain page. We use hash based routes like `#/profile/auth`
 * to instruct frontend to open specific page in Profile MFE. This function handles
 * such hash based navigation.
 */
const handleHashNavigation = () => {
    const hash = window.location.hash;
    if (hash && hash.includes('profile')) {
        const profileRoute = hash.replace('#', '');
        router.push(profileRoute);
    }
}

handleHashNavigation();

export default router;